var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// $FlowFixMe
import { useState, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { find, map, filter, uniqBy } from 'lodash';
import { Badge, Popover } from '@mui/material';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import resources from 'app/store/resources';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
import { ModalTrigger, ModalConfirmForm, openModal } from 'app/components/Modal';
import { router as routerTaskDetail } from 'app/containers/Task/router';
import { getResources } from 'app/store/selectors';
import { MyHoursCalendar } from 'app/containers/MyHoursCalendar/MyHoursCalendar.jsx';
import { ResizableCol } from 'app/components/ResizableContainer';
import { setUserSettings, getUserSettings } from 'app/libs/helpers/userSettings';
import { ToggleButtonGroup, ToggleButton, FormData } from 'app/components/Form';
import { Filters } from '../Filters.js';
import classes from '../MyHours.module.scss';
import { HowToUserHours } from 'app/pages/MyHours/HowTo';
import { TableMyHoursCustomActivities } from 'app/pages/MyHours/TableMyHoursCustomActivities/TableMyHoursCustomActivities';
import { ModalAddCustomActivity } from 'app/pages/MyHours/ModalAddCustomActivity';
import { ModalAddAbsenceActivity } from 'app/pages/MyHours/ModalAddAbsenceActivity';
import TableTimeRecapLeaves from 'app/pages/HR/TimeRecap/TableTimeReacapLeaves/TableTimeRecapLeaves';
import { fetchAllUserLeaves } from 'app/store/reducers/leaves';
import { fetchMyActivities } from 'app/store/reducers/reduxActivities';
import { myActivitiesSelector } from 'app/store/selectors/reduxActivities';
import { TableRedux } from 'app/components/Table/TableRedux';
import { fetchMyPastTasks, fetchMyTasks, resetTableTasks } from 'app/store/reducers/tasks';
import { allTasksByTableWithRelationsSelector, tasksByTableSelector } from 'app/store/selectors/tasks';
import { setActiveTableId, setTablePage } from 'app/store/reducers/tablesPrefs';
import { tableUserPrefsDataSelector } from 'app/store/selectors/tableUserPrefs';
import { filtersToURL, urlToFilters, filtersToQueries } from 'app/components/Table/hooks/useFiltersUtils.js';
import { tableFiltersDataSelector, tableFiltersForQueriesSelector } from 'app/store/selectors/tablesFilters';
import { getURLParamsKey } from 'app/components/Table/utils.js';
import routerHistory from 'app/main/routerHistory.js';
import { resetReduxTableFilters, setAndApplyInputFilters } from 'app/store/reducers/tablesFilters';
import getColumns from './columns';
export const TableMyHours = (props) => {
    var _a, _b;
    const { tableId, selectedWeek, formatView, history, taskType, match } = props;
    const dispatch = useDispatch();
    const { search } = useLocation();
    const startDate = useMemo(() => moment(selectedWeek).startOf(formatView), [formatView, selectedWeek]);
    const endDate = useMemo(() => moment(selectedWeek).endOf(formatView), [formatView, selectedWeek]);
    const startDateString = useMemo(() => startDate.format('YYYY-MM-DD'), [startDate]);
    const endDateString = useMemo(() => endDate.format('YYYY-MM-DD'), [endDate]);
    const allotmentTasks = taskType === 'alt';
    const [pastTasks, togglePastTasks] = useState(false);
    const [toggleCustomActivities, setToggleCustomActivities] = useState(getUserSettings('MyHours-customActivity') === 'true');
    const [progressionStatus, setProgressionStatus] = useState();
    const [projects, setProjects] = useState([]);
    const [steps, setSteps] = useState();
    const [URLParamsParsed, setURLParamsParsed] = useState(false);
    const myCustomActivitiesInstanceRef = useRef();
    const isMount = useRef(true);
    const ordering = useSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state.tablesPrefs.data) === null || _a === void 0 ? void 0 : _a[tableId]) === null || _b === void 0 ? void 0 : _b.sortBy) === null || _c === void 0 ? void 0 : _c.orderingString; });
    const reduxPage = useSelector((state) => state.tablesPrefs.page);
    const tableUserPrefs = useSelector(tableUserPrefsDataSelector(tableId));
    const activities = useSelector(myActivitiesSelector);
    const { count = 0, loading: tasksLoading = true, httpProgress = 0 } = (_a = useSelector(tasksByTableSelector(tableId))) !== null && _a !== void 0 ? _a : {};
    const { data: userLeaves } = useSelector((state) => state.leaves);
    const user = useSelector((state) => state.user);
    const filtersData = (_b = useSelector(tableFiltersDataSelector(tableId))) !== null && _b !== void 0 ? _b : [];
    const filtersForQueries = useSelector(tableFiltersForQueriesSelector(tableId));
    const data = useSelector(allTasksByTableWithRelationsSelector(tableId));
    const getLeaveDayPart = (date, leave) => {
        if (!leave)
            return null;
        const formattedDate = moment(date).format('YYYY-MM-DD');
        const formattedLeaveStartDate = moment(leave === null || leave === void 0 ? void 0 : leave.startDate).format('YYYY-MM-DD');
        const leaveStartHour = moment.utc(leave === null || leave === void 0 ? void 0 : leave.startDate).format('HH');
        const formattedLeaveEndDate = moment(leave === null || leave === void 0 ? void 0 : leave.endDate).format('YYYY-MM-DD');
        const leaveEndHour = moment.utc(leave === null || leave === void 0 ? void 0 : leave.endDate).format('HH');
        if (formattedDate === formattedLeaveEndDate && Number(leaveEndHour) < 18)
            return 'morning';
        if (formattedDate === formattedLeaveStartDate && Number(leaveStartHour) > 8)
            return 'afternoon';
        return 'fullday';
    };
    const filters = useMemo(() => {
        if (steps)
            return new Filters({ status: progressionStatus || {}, steps }).getFilters();
        return undefined;
    }, [progressionStatus, steps]);
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (user === null || user === void 0 ? void 0 : user.asset) {
                dispatch(fetchAllUserLeaves());
            }
        }))();
    }, [user]);
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (user === null || user === void 0 ? void 0 : user.asset) {
                dispatch(fetchMyActivities({ date__range: `${startDateString},${endDateString}`, page: 1, page_size: 1000 }));
            }
        }))();
    }, [startDate, endDate, user]);
    useEffect(() => {
        dispatch(setActiveTableId(tableId));
        return () => {
            dispatch(resetReduxTableFilters(tableId));
            dispatch(resetTableTasks(tableId));
        };
    }, []);
    useEffect(() => {
        Promise.all([
            resources.progressionStatus.fetchAll({ params: { queries: { page_size: 1000 } } }),
            resources.steps.fetchAll({ params: { queries: { page_size: 1000 } } }),
        ]).then(() => {
            if (!isMount.current)
                return;
            setProgressionStatus(getResources(undefined, 'progressionStatus'));
            setProjects(map(user.projects));
            setSteps(getResources(undefined, 'steps'));
        });
        return () => {
            isMount.current = false;
        };
    }, []);
    const userTaskActivities = useSelector((state) => filter(getResources(state, 'activities', (activity) => Boolean(activity.user === user.asset &&
        activity.date >= startDateString &&
        activity.date <= endDateString &&
        activity.task), ['taskInst']))) || [];
    function getActivitiesSumByDate(date) {
        return uniqBy([...userTaskActivities, ...activities], 'id').filter((activity) => {
            var _a, _b, _c, _d;
            if (taskType && ((_b = (_a = activity === null || activity === void 0 ? void 0 : activity.taskInst) === null || _a === void 0 ? void 0 : _a.taskTypeInst) === null || _b === void 0 ? void 0 : _b.name) && ((_d = (_c = activity === null || activity === void 0 ? void 0 : activity.taskInst) === null || _c === void 0 ? void 0 : _c.taskTypeInst) === null || _d === void 0 ? void 0 : _d.name) !== taskType)
                return false;
            return activity.date === date && user.asset === activity.user;
        });
    }
    function findActivity(activitiesInst, date) {
        return find(activitiesInst, (activity) => {
            return activity.date === date && user.asset === activity.user && !activity.activityType;
        });
    }
    function defaultActions(instance, cell) {
        return [
            { separator: true },
            {
                label: 'Show task details',
                onClick: (e) => routerTaskDetail.goTo('index', { taskId: cell.row.original.id }, { rightPanel: true }),
                editAction: false,
            },
        ];
    }
    function addTimeOnSelection(instance, cell) {
        return {
            label: 'Add time on selection',
            editAction: true,
            onClick: (e) => {
                var _a;
                const { save } = ((_a = cell.getCellProps()) === null || _a === void 0 ? void 0 : _a.edition) || {};
                return openModal(_jsx(ModalConfirmForm, { title: "Add time on selected tasks", children: _jsx(FormData, { onSave: ({ duration }) => {
                            const { selectedCells } = instance.getLastestSelection();
                            const value = Math.round(duration / Object.keys(selectedCells || {}).length);
                            return save({ duration: value });
                        }, properties: [
                            {
                                label: 'Duration',
                                key: 'duration',
                                type: 'duration',
                                elementProps: {
                                    isRequired: true,
                                    hide: { days: true },
                                },
                            },
                        ] }) }));
            },
        };
    }
    function addCustomActivity(instance, cell) {
        const date = moment(cell.id, 'YYYY-MM-DD');
        return {
            label: 'Add an other activity',
            editAction: true,
            onClick: (e) => {
                return openModal(_jsx(ModalAddCustomActivity, { useRedux: true, userId: user.asset, preSelectedDate: date.toDate() }));
            },
        };
    }
    function addLeave(instance, cell) {
        const { selectedCells } = instance.getLastestSelection();
        const date = moment(cell.id, 'YYYY-MM-DD');
        function openLeaveModal(duration, dayPart = '', period = false) {
            return openModal(_jsx(ModalAddAbsenceActivity, { userId: user.asset, dayPart: dayPart, tableTime: true, period: period, preSelectedDate: selectedCells && Object.keys(selectedCells).length === 1 ? date.toDate() : undefined, duration: duration, preSelectedCells: selectedCells, onChange: (activities) => {
                    if (!myCustomActivitiesInstanceRef.current)
                        return;
                    const { setStateData, data } = myCustomActivitiesInstanceRef.current;
                    const newData = [...activities, ...data];
                    setStateData(newData.reduce((acc, activity) => {
                        acc[activity.id] = activity;
                        return acc;
                    }, {}));
                } }));
        }
        return {
            label: 'Add a leave',
            editAction: true,
            items: selectedCells && Object.keys(selectedCells).length < 2
                ? [
                    {
                        label: 'Morning',
                        editAction: true,
                        onClick: () => openLeaveModal(60 * 60 * 4, 'morning'),
                    },
                    {
                        label: 'Afternoon',
                        editAction: true,
                        onClick: () => openLeaveModal(60 * 60 * 4, 'afternoon'),
                    },
                    {
                        label: 'Full day',
                        editAction: true,
                        onClick: () => openLeaveModal(60 * 60 * 8, ''),
                    },
                ]
                : [
                    {
                        label: 'Period',
                        editAction: true,
                        onClick: () => openLeaveModal(60 * 60 * 8, '', true),
                    },
                ],
        };
    }
    function onChangeSelectWeek(type, week) {
        const url = match.url.split('/')[1];
        history.pushWithQuery({}, `/${url}/${type}/${week.format(type === 'month' ? 'MM-YYYY' : 'w-YYYY')}`);
    }
    function getExtendToolbar(instance) {
        const customActivitiesNb = userTaskActivities.reduce((acc, activity) => {
            return activity.user === user.asset &&
                activity.activityType &&
                moment(activity.date).isSame(selectedWeek, formatView)
                ? acc + 1
                : acc;
        }, 0);
        return (_jsxs(_Fragment, { children: [_jsx(ModalTrigger, { modal: _jsx(HowToUserHours, {}), children: _jsx(FontIcon, { icon: "fas-info-circle", className: classes.infoButton }) }), _jsxs(ToggleButtonGroup, { className: "marginRight10", children: [_jsx(ToggleButton, { selected: formatView === 'week', disabled: formatView === 'week', onClick: () => onChangeSelectWeek('week', selectedWeek), children: "Week" }), _jsx(ToggleButton, { selected: formatView === 'month', disabled: formatView === 'month', onClick: () => onChangeSelectWeek('month', selectedWeek), children: "Month" })] }), allotmentTasks ? null : (_jsxs(ToggleButtonGroup, { style: { marginRight: 10 }, children: [_jsx(ToggleButton, { icon: "far-square", onClick: () => togglePastTasks(false), selected: !pastTasks, children: "Current" }), _jsx(ToggleButton, { icon: "fas-check-square", onClick: () => togglePastTasks(true), selected: pastTasks, children: "Past" })] })), _jsx(PopupState, { variant: "popover", popupId: "calendar", children: (popupState) => {
                        const _props = bindTrigger(popupState);
                        return (_jsxs(_Fragment, { children: [_jsxs(ToggleButtonGroup, { className: "marginRight10", children: [_jsx(ToggleButton, { onClick: () => {
                                                const previous = moment(selectedWeek).subtract(1, formatView);
                                                onChangeSelectWeek(formatView, previous);
                                            }, children: _jsx(FontIcon, { icon: "fas-chevron-left" }) }), _jsx(ToggleButton, Object.assign({ icon: "fas-calendar" }, _props, { children: formatView === 'week' ? (_jsxs(_Fragment, { children: [startDate.format('DD/MM/YYYY'), " - ", endDate.format('DD/MM/YYYY')] })) : (_jsx("span", { className: "capitalize", children: startDate.format('MMMM YYYY') })) })), _jsx(ToggleButton, { onClick: () => {
                                                const next = moment(selectedWeek).add(1, formatView);
                                                onChangeSelectWeek(formatView, next);
                                            }, children: _jsx(FontIcon, { icon: "fas-chevron-right" }) })] }), _jsx(Popover, Object.assign({}, bindPopover(popupState), { anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }, transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }, children: _jsx(MyHoursCalendar, { display: formatView, selectedWeek: selectedWeek, userId: user.asset, onSelectWeek: (startWeek) => onChangeSelectWeek(formatView, startWeek), onSelectMonth: (month) => onChangeSelectWeek(formatView, month) }) }))] }));
                    } }), _jsx(Badge, { overlap: "circular", badgeContent: customActivitiesNb, color: "primary", invisible: toggleCustomActivities || customActivitiesNb === 0, children: _jsx(ToggleButton, { selected: toggleCustomActivities, style: { marginLeft: 10 }, onClick: () => {
                            setUserSettings('MyHours-customActivity', String(!toggleCustomActivities));
                            setToggleCustomActivities(!toggleCustomActivities);
                        }, children: "Other activities" }) })] }));
    }
    const columns = useMemo(() => {
        const accumulator = moment(startDate);
        const selectedDays = [];
        while (accumulator.toDate() < endDate.toDate()) {
            selectedDays.push(moment(accumulator));
            accumulator.add(1, 'day');
        }
        return getColumns({
            dispatch,
            history,
            defaultActions,
            projects,
            progressionStatus,
            selectedDays,
            user,
            addTimeOnSelection,
            addCustomActivity,
            findActivity,
            addLeave,
            userLeaves,
            getLeaveDayPart,
            formatView,
            startDateString,
            endDateString,
            userTaskActivities,
            activities,
            startDate,
            endDate,
            getActivitiesSumByDate,
        });
    }, [startDate, endDate, progressionStatus, formatView, userTaskActivities]);
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (search && (filters === null || filters === void 0 ? void 0 : filters.length)) {
                const params = new URLSearchParams(search);
                const urlCurrentFilters = params.get(getURLParamsKey('filters', tableId));
                if (urlCurrentFilters) {
                    const urlFilters = yield urlToFilters(urlCurrentFilters, filters, undefined, undefined, false);
                    dispatch(setAndApplyInputFilters({ tableId, value: urlFilters }));
                }
            }
            if (!search && (filters === null || filters === void 0 ? void 0 : filters.length) && (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length)) {
                dispatch(resetReduxTableFilters(tableId));
            }
            setURLParamsParsed(true);
        }))();
    }, [filters]);
    useEffect(() => {
        const url = filtersToURL(filtersData !== null && filtersData !== void 0 ? filtersData : []);
        routerHistory.updateQuery({ [getURLParamsKey('filters', tableId)]: url || null });
    }, [filtersData]);
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (URLParamsParsed) {
                const { queries: filtQueries } = filtersToQueries(filtersForQueries !== null && filtersForQueries !== void 0 ? filtersForQueries : []);
                const params = {
                    queries: Object.assign({ status__statusType__in: allotmentTasks ? undefined : pastTasks ? '3' : '0,2,4', page_size: (tableUserPrefs === null || tableUserPrefs === void 0 ? void 0 : tableUserPrefs.pageSize) || 50, page: reduxPage + 1, ordering, [`taskType__name${!allotmentTasks ? '!' : ''}`]: 'alt' }, filtQueries),
                };
                pastTasks ? dispatch(fetchMyPastTasks({ tableId, params })) : dispatch(fetchMyTasks({ tableId, params }));
            }
        }))();
    }, [
        startDate,
        endDate,
        pastTasks,
        allotmentTasks,
        ordering,
        tableUserPrefs === null || tableUserPrefs === void 0 ? void 0 : tableUserPrefs.pageSize,
        filtersForQueries,
        URLParamsParsed,
        reduxPage,
    ]);
    if (!steps || !progressionStatus)
        return null;
    return (_jsx("div", { className: "flex fullWidth fullHeight", "data-testid": "page-table-my-hours", children: _jsx(ResizableCol, { defaultLeftSize: formatView === 'month' ? 3 : 2, optionName: "UserHoursVertResizing", toggleRight: toggleCustomActivities, disabled: undefined, left: _jsx(TableRedux, { loading: tasksLoading, progress: httpProgress, tableId: tableId, data: data, count: count, columns: columns, filters: filters, lockColumnOrder: true, extendToolbar: getExtendToolbar, tableViewKey: `${startDate.toISOString()}-${endDate.toISOString()}-${String(pastTasks)}-${String(toggleCustomActivities)}`, page: reduxPage, setPage: (val) => dispatch(setTablePage(val)) }), right: _jsxs("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                }, children: [_jsx(TableMyHoursCustomActivities, { user: user, projects: projects, getInstance: (instance) => {
                            myCustomActivitiesInstanceRef.current = instance;
                        }, formatView: formatView, selectedWeek: selectedWeek }), _jsx(TableTimeRecapLeaves, { userId: user.asset, formatView: formatView, selectedWeek: selectedWeek })] }) }) }));
};
